import { Protocol } from '@orbital/games-frontend-library'
import { sendStakes } from '../settings/useSettings'

export const useHoldemSocketMessages = (sendSocketMessage: any) => {

    const handleDeal = (ante: string, aa: string) => {
        sendStakes(ante, aa)
        sendSocketMessage(Protocol.START_ROUND, ante.toString(), aa.toString())
    }
    const handleRaise = () => sendSocketMessage(Protocol.STEP_ROUND)
    const handleFold = () => sendSocketMessage(Protocol.END_ROUND)


    return {
        handleDeal,
        handleRaise,
        handleFold,
    }
}